export default "__VITE_ASSET__DoAQzc1B__"